module.exports = __webpack_public_path__ + "img/pic_app03.0cce54e4.png";